<template>
  <span>
    <b-button
      variant="link"
      size="sm"
      class="p-0"
      style="font-size: 12px;"
      @click="onClick">
      {{isShown ? 'Hide' : 'Show'}} details
    </b-button>
  </span>
</template>

<script>
  export default {
    name: 'RunVersionCell',
    computed: {
      runId() {
        return this.params.data.run_id;
      },
      isShown() {
        const {changeLogsRun} = this.params.context.parent;
        return changeLogsRun && changeLogsRun.run_id === this.runId;
      }
    },
    methods: {
      onClick() {
        // sorry for this hack, but cell renderer components are hard to make working within async components
        this.params.context.parent.toggleChangelog(this.params.data);
      },
    },
  };
</script>

<style scoped>
</style>
